<template>
  <div>
    <div class="column columns is-mutltiline  padding-produit
       is-align-items-flex-end ml-20 mb-0px">
        <div class="column columns is-narrow pb-0px pr-0px is-marginless">
          <b-checkbox size="is-large" class="panier-checkbox mr-0px"
                      v-model="selectAll"
                      :value="selectAll"
                      :disabled="disabled"
                      @input="selectionnerToutProduits">
          </b-checkbox>
          <b-field>
            <b-select placeholder="Actions groupées"
                      v-model="action"
                      :disabled="!onSelected">
              <option value="1">Créer un réseau personnalisé</option>
              <option value="2">Supprimer</option>
            </b-select>
          </b-field>
        </div>
       <div class="column is-narrow is-paddingless ml-10">
         <button class="button is-primary" :disabled="!action"
                  @click="appliquerAction()">
            Appliquer
          </button>
       </div>
       <div class="column is-4 is-paddingless ml-10">
         <div class="control" v-if="$route.name !== 'detailopportunite'">
            <label class="has-text-default has-text-weight-bold">
              Thème de la campagne</label>
            <b-input type="text"
             v-model="themeCampagne"
             :disabled="disabled"></b-input>
          </div>
          <div class="control"  v-else>
            <label class="has-text-default has-text-weight-bold">
              Thème de la campagne</label>
            <b-input type="text"
             v-model="panier.themeCampagne"
             :disabled="disabled"></b-input>
          </div>
       </div>
       <div class="column is-2 is-paddingless ml-10">
         <b-field label="Date de validité" v-if="$route.name !== 'detailopportunite'"
                  custom-class="mb-0px has-text-default">
            <b-datepicker
              icon="calendar-today"
              :readonly="false"
              :disabled="disabled"
              v-model="dateValidite"/>
              <p class="control">
                <button
                  class="button is-light is-outlined"
                  id="clean-date-valid-panier"
                  @click="dateValidite = null">
                  <b-icon type="is-danger" icon="close"></b-icon>
                </button>
              </p>
          </b-field>
          <b-field v-else
            label="Date de validité"
            custom-class="mb-0 has-text-default">
              <b-datepicker
                icon="calendar-today"
                :readonly="false"
                :disabled="disabled"
                v-model="panier.dateValidite"/>
          </b-field>
       </div>
       <div class="column is-paddingless">
         <div class="level">
           <div class="level-left"></div>
           <div class="level-right mr-12">
             <b-tag
              size="is-medium"
              class="width-190 has-text-weight-bold"
              type="is-white">
              {{prixGlobal}} €
            </b-tag>
           </div>
         </div>
       </div>
    </div>
    <div class="padding-produit ml-20">
      <div v-if="produits.panneauxLc.length  &&
          produits.panneauxLc.filter((el) => {
            return el.extensionOpportunite.reseauPersoGuid;
          }).length !== produits.panneauxLc.length">
        <div class="level">
          <div class="card collapse-produit">
            <div class="level-left">
              <div class=" is-marginless">
                <b-checkbox size="is-large" class="panier-checkbox my-10 ml-15"
                            v-model="selectAllPanneauxLc"
                            :value="selectAllPanneauxLc"
                            :disabled="disabled"
                            @input="selectionnerTout('panneauxLc', selectAllPanneauxLc)">
                </b-checkbox>
              </div>
              <div class="level-item is-marginless">
                <div @click="isOpenFacesLc = !isOpenFacesLc">
                  <div class="level-left">
                    <b-icon class="iconFacesLc"
                            :icon="isOpenFacesLc ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                    Faces Unitaires
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-collapse class="panel" v-model="isOpenFacesLc">
          <div
            v-for="produit in produits.panneauxLc
              .filter(el => !el.extensionOpportunite.reseauPersoGuid)"
            :key="`panneau_lc_${produit.num}`"
            class="level card card-panneau">
            <div class="column is-narrow ml-10">
              <b-checkbox size="is-large" class="panier-checkbox positionCheckbox ml-15"
                          :value="produit.selected"
                          v-model="produit.selected"
                          :disabled="disabled"
                          @input="selectAllPanneauxLc = verifierSelection('panneauxLc',
                            selectAllPanneauxLc)">
              </b-checkbox>
            </div>
            <app-ventes-lc
              class="collapse-produit"
              :panneau="produit"
              :disabled="disabled"/>
          </div>
        </b-collapse>
      </div>
      <div v-if="produits.reseauxTempo.length &&
          produits.reseauxTempo.filter((el) => {
            return el.extensionOpportunite.reseauPersoGuid;
          }).length !== produits.reseauxTempo.length"
          class="mt-10">
        <div class="level">
          <div class="card collapse-produit">
            <div class="level-left">
              <div class="level-item is-marginless">
                <b-checkbox size="is-large" class="panier-checkbox my-10 ml-15"
                            v-model="selectAllReseauxTempo"
                            :disabled="disabled"
                            :value="selectAllReseauxTempo"
                            @input="selectionnerTout('reseauxTempo', selectAllReseauxTempo)">
                </b-checkbox>
              </div>
              <div class="level-item is-marginless">
                <div @click="isOpenReseauxTempo = !isOpenReseauxTempo">
                  <div class="level-left">
                    <b-icon class="iconFacesLc"
                            :icon="isOpenReseauxTempo ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                    Réseaux Temporaires
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-collapse class="panel" v-model="isOpenReseauxTempo">
          <div
              v-for="p in produits.reseauxTempo
                .filter(el => !el.extensionOpportunite.reseauPersoGuid)"
              :key="`${p.num}_${p.extensionOpportunite.annee}_${p.extensionOpportunite.semaine}`"
              class="level card card-panneau">
            <div class="column is-narrow ml-10">
              <b-checkbox size="is-large" class="panier-checkbox positionCheckbox ml-15"
                          :value="p.selected"
                          v-model="p.selected"
                          :disabled="disabled"
                          @input="selectAllReseauxTempo = verifierSelection('reseauxTempo',
                            selectAllReseauxTempo)">
              </b-checkbox>
            </div>
            <app-vente-reseaux-tempo
              class="collapse-produit"
              :reseau="p"
              :disabled="disabled"/>
          </div>
        </b-collapse>
      </div>
      <div v-if="produits.reseauxLc.length &&
          produits.reseauxLc.filter((el) => {
            return el.extensionOpportunite.reseauPersoGuid;
          }).length !== produits.reseauxLc.length"
          class="mt-10">
        <div class="level">
          <div class="card collapse-produit">
            <div class="level-left">
              <div class="level-item is-marginless">
                <b-checkbox size="is-large" class="panier-checkbox my-10 ml-15"
                            v-model="selectAllReseauxLc"
                            :disabled="disabled"
                            :value="selectAllReseauxLc"
                            @input="selectionnerTout('reseauxLc', selectAllReseauxLc)">
                </b-checkbox>
              </div>
              <div class="level-item is-marginless">
                <div @click="isOpenReseauxLc = !isOpenReseauxLc">
                  <div class="level-left">
                    <b-icon class="iconFacesLc"
                            :icon="isOpenReseauxLc ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                    Réseaux Lc
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-collapse class="panel" v-model="isOpenReseauxLc">
          <div
            v-for="produit in produits.reseauxLc
              .filter(el => !el.extensionOpportunite.reseauPersoGuid)"
            :key="`reseau_lc_${produit.num}`"
            class="level card card-panneau">
            <div class="column is-narrow ml-10">
              <b-checkbox size="is-large" class="panier-checkbox positionCheckbox ml-15"
                          :value="produit.selected"
                          v-model="produit.selected"
                          :disabled="disabled"
                          @input="selectAllReseauxLc = verifierSelection('reseauxLc',
                            selectAllReseauxLc)">
              </b-checkbox>
            </div>
            <app-vente-reseaux-Lc
              class="collapse-produit"
              :reseau="produit"
              :disabled="disabled"/>
          </div>
        </b-collapse>
      </div>
      <div v-if="produits.panneauxNumeriques.length  &&
          produits.panneauxNumeriques.filter((el) => {
            return el.extensionOpportunite.reseauPersoGuid;
          }).length !== produits.panneauxNumeriques.length"
          class="mt-10">
        <div class="level">
          <div class="card collapse-produit">
            <div class="level-left">
              <div class="level-item is-marginless">
                <b-checkbox size="is-large" class="panier-checkbox my-10 ml-15"
                        v-model="selectAllPanneauxNumeriques"
                        :disabled="disabled"
                        :value="selectAllPanneauxNumeriques"
                        @input="selectionnerTout('panneauxNumeriques',
                         selectAllPanneauxNumeriques)">
                </b-checkbox>
              </div>
              <div class="level-item is-marginless">
                <div @click="isOpenPanneauxNumeriques = !isOpenPanneauxNumeriques">
                  <div class="level-left">
                    <b-icon class="iconFacesLc"
                            :icon="isOpenPanneauxNumeriques ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                    Panneaux numériques
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-collapse class="panel" v-model="isOpenPanneauxNumeriques">
          <div
              v-for="produit in produits.panneauxNumeriques
                .filter(el => !el.extensionOpportunite.reseauPersoGuid)"
              :key="`panneau_numerique_${produit.num}`"
              class="level card card-panneau">
            <div class="column is-narrow ml-10">
              <b-checkbox size="is-large" class="panier-checkbox positionCheckbox ml-15"
                          :value="produit.selected"
                          v-model="produit.selected"
                          :disabled="disabled"
                          @input="selectAllPanneauxNumeriques = verifierSelection(
                            'panneauxNumeriques',
                            selectAllPanneauxNumeriques)">
              </b-checkbox>
            </div>
            <app-panneau-numerique
              class="collapse-produit"
              :panneau="produit"
              :disabled="disabled"/>
          </div>
        </b-collapse>
      </div>
      <div v-if="produits.reseauxNumeriques.length  &&
        produits.reseauxNumeriques.filter((el) => {
          return el.extensionOpportunite.reseauPersoGuid;
        }).length !== produits.reseauxNumeriques.length"
        class="mt-10">
        <div class="level">
          <div class="card collapse-produit">
            <div class="level-left">
              <div class="level-item is-marginless">
                <b-checkbox size="is-large" class="panier-checkbox my-10 ml-15"
                        v-model="selectAllReseauxNumeriques"
                        :disabled="disabled"
                        :value="selectAllReseauxNumeriques"
                        @input="selectionnerTout('reseauxNumeriques', selectAllReseauxNumeriques)">
                </b-checkbox>
              </div>
              <div class="level-item is-marginless">
                <div @click="isOpenReseauxNumeriques = !isOpenReseauxNumeriques">
                  <div class="level-left">
                    <b-icon class="iconFacesLc"
                            :icon="isOpenReseauxNumeriques ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                    Réseaux numériques
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-collapse class="panel" v-model="isOpenReseauxNumeriques">
          <div
              v-for="produit in produits.reseauxNumeriques
                .filter(el => !el.extensionOpportunite.reseauPersoGuid)"
              :key="`reseau_numerique_${produit.num}`"
              class="level card card-panneau">
            <div class="column is-narrow ml-10">
              <b-checkbox size="is-large" class="panier-checkbox positionCheckbox ml-15"
                          :value="produit.selected"
                          v-model="produit.selected"
                          :disabled="disabled"
                          @input="selectAllReseauxNumeriques = verifierSelection(
                            'reseauxNumeriques',
                            selectAllReseauxNumeriques)">
              </b-checkbox>
            </div>
            <app-reseau-numerique
              class="collapse-produit"
              :reseau="produit"
              :disabled="disabled"/>
          </div>
        </b-collapse>
      </div>
      <div v-if="produits.reseauxPersonnalise.length" class="mt-10">
        <div class="level">
            <div class="card collapse-produit">
              <div class="level-left">
              <div class="level-item is-marginless">
                <b-checkbox size="is-large" class="panier-checkbox my-10 ml-15"
                            v-model="selectAllReseauxPersonnalise"
                            :disabled="disabled"
                            :value="selectAllReseauxPersonnalise"
                            @input="selectionnerTout('reseauxPersonnalise',
                              selectAllReseauxPersonnalise)">
                </b-checkbox>
              </div>
              <div class="level-item is-marginless">
                <div @click="isOpenReseauxPersonnalise = !isOpenReseauxPersonnalise">
                  <div class="level-left">
                    <b-icon class="iconFacesLc"
                            :icon="isOpenReseauxPersonnalise ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                    Réseaux personnalisés
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        <b-collapse class="panel" v-model="isOpenReseauxPersonnalise">
          <div
              v-for="produit in produits.reseauxPersonnalise"
              :key="`reseau_personnalise_${produit.guid}`"
              class="level card card-panneau">
            <div class="column is-narrow ml-10">
              <b-checkbox size="is-large" class="panier-checkbox positionCheckbox ml-15"
                          :value="produit.selected"
                          v-model="produit.selected"
                          :disabled="disabled"
                          @input="selectAllReseauxPersonnalise = verifierSelection(
                            'reseauxPersonnalise',
                            selectAllReseauxPersonnalise)">
              </b-checkbox>
            </div>
            <app-reseaux-personnalise
              class="collapse-produit is-pulled-right"
              :reseau="produit"
              :disabled="disabled"/>
          </div>
        </b-collapse>
      </div>
      <div class="column level">
        <div class="level-right">
            <b-tag
              size="is-medium"
              class="width-200 has-text-weight-bold"
              type="is-white">
              {{prixGlobal}} €
            </b-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import * as typesClient from '@/store/modules/client-mutation-type';
import ventesLc from '@/components/creationOpportunite/panier/composantsProduits/ventesLc';
import venteReseauxTempo from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo';
import venteReseauxLc from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxLc';
import ReseauxPersonnalise from '@/components/creationOpportunite/panier/composantsProduits/reseauxPersonnalise';
import panneauNumerique from '@/components/creationOpportunite/panier/composantsProduits/panneauNumerique';
import reseauNumerique from '@/components/creationOpportunite/panier/composantsProduits/reseauNumerique';
import arrondiResult from '@/services/general/arrondiCalcul';

const Panier = createNamespacedHelpers('panier');
const Client = createNamespacedHelpers('client');

export default {
  name: 'produits',
  components: {
    appVentesLc: ventesLc,
    appVenteReseauxTempo: venteReseauxTempo,
    appVenteReseauxLc: venteReseauxLc,
    appReseauxPersonnalise: ReseauxPersonnalise,
    appPanneauNumerique: panneauNumerique,
    appReseauNumerique: reseauNumerique,
  },
  props: ['produits', 'disabled', 'panier'],
  data() {
    return {
      isOpenReseauxTempo: true,
      isOpenReseauxLc: true,
      isOpenFacesLc: true,
      isOpenReseauxPersonnalise: true,
      isOpenReseauxNumeriques: true,
      isOpenPanneauxNumeriques: true,
      selectAllPanneauxLc: false,
      selectAllReseauxTempo: false,
      selectAllReseauxLc: false,
      selectAllPanneauxNumeriques: false,
      selectAllReseauxNumeriques: false,
      selectAllReseauxPersonnalise: false,
      isComponentViderPanier: false,
      selectAll: false,
      onSelected: null,
      typesProduits: [
        'panneauxLc',
        'reseauxTempo',
        'reseauxLc',
        'panneauxNumeriques',
        'reseauxNumeriques',
        'reseauxPersonnalise',
      ],
      action: null,
    };
  },
  watch: {},
  mounted() {
    if (this.produits.panneauxLc.filter((el) => {
      return el.selected;
    }).length ===
      this.produits.panneauxLc.length) {
      this.selectAllPanneauxLc = true;
    }
    if (this.produits.reseauxTempo.filter((el) => {
      return el.selected;
    }).length ===
      this.produits.reseauxTempo.length) {
      this.selectAllReseauxTempo = true;
    }
    if (this.produits.reseauxLc.filter((el) => {
      return el.selected;
    }).length ===
      this.produits.reseauxLc.length) {
      this.selectAllReseauxLc = true;
    }
    if (this.produits.panneauxNumeriques.filter((el) => {
      return el.selected;
    }).length ===
      this.produits.panneauxNumeriques.length) {
      this.selectAllPanneauxNumeriques = true;
    }
    if (this.produits.reseauxNumeriques.filter((el) => {
      return el.selected;
    }).length ===
      this.produits.reseauxNumeriques.length) {
      this.selectAllReseauxNumeriques = true;
    }
  },
  computed: {
    ...Panier.mapGetters({
      getContactPanier: 'contactPanier',
      getClientPanier: 'clientPanier',
      getDateValidite: 'dateValidite',
      getThemeCampagne: 'themeCampagne',
      prixGlobalPanier: 'prixGlobal',
    }),
    ...Client.mapGetters({
      getClient: 'client',
    }),
    contactPanier: {
      get() {
        return this.getContactPanier;
      },
      set(value) {
        this.setContactPanier(value);
      },
    },
    clientPanier: {
      get() {
        return this.getClientPanier;
      },
      set(value) {
        this.setClientPanier(value);
      },
    },
    client: {
      get() {
        return this.getClient;
      },
      set(value) {
        this.setClient(value);
      },
    },
    produitsLc() {
      return this.produits.panneauxLc
        .filter(el => !el.extensionOpportunite.reseauPersoGuid);
    },
    themeCampagne: {
      get() {
        return this.getThemeCampagne;
      },
      set(value) {
        this.setThemeCampagne(value);
      },
    },
    dateValidite: {
      get() {
        return this.getDateValidite;
      },
      set(value) {
        this.setDateValidite(value);
      },
    },
    prixGlobal() {
      if (this.disabled) {
        return arrondiResult(
          Object.values(this.produits)
            .flat().map(el => el.prixTotal)
            .filter(el => el !== undefined)
            .reduce((el1, el2) => el1 + el2, 0),
        );
      }
      return this.prixGlobalPanier;
    },
  },
  methods: {
    ...Panier.mapMutations({
      setContactPanier: typesPanier.SET_CONTACT_PANIER,
      setClientPanier: typesPanier.SET_CLIENT_PANIER,
      setResetPanier: typesPanier.RESET_PANIER,
      setRemoveProduit: typesPanier.REMOVE_PRODUIT_TYPE_PANNEAU,
      setRemoveProduitPanNum: typesPanier.REMOVE_PRODUIT_TYPE_PANNEAU_NUMERIQUE,
      setRemoveProduitReseauLC: typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_LC,
      setRemoveProduitReseauxTempo: typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_TEMPO,
      setRemoveProduitReseauxNum: typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_NUMERIQUE,
      setRemoveProduitReseauxPerso: typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_PERSO,
      setDateValidite: typesPanier.SET_DATE_VALIDITE,
      setThemeCampagne: typesPanier.SET_THEME_CAMPAGNE,
    }),
    ...Client.mapMutations({
      setClient: typesClient.SET_CLIENT,
    }),
    selectionnerTout(produit, select, notVerifAll) {
      this.produits[produit].forEach((el) => {
        el.selected = select;
      });
      if (!notVerifAll) this.verificationAllSection();
      this.onSelected = Object.values(this.produits).flat().map(el => el.selected).includes(true);
    },
    selectionnerToutProduits(val) {
      this.typesProduits.forEach(type => {
        this.selectionnerTout(type, val, true);
      });
      this.selectAllPanneauxLc = val;
      this.selectAllReseauxTempo = val;
      this.selectAllReseauxLc = val;
      this.selectAllPanneauxNumeriques = val;
      this.selectAllReseauxNumeriques = val;
      this.selectAllReseauxPersonnalise = val;
    },
    verifierSelection(produit, val) {
      this.onSelected = Object.values(this.produits).flat().map(el => el.selected).includes(true);
      if (produit === 'reseauxPersonnalise') {
        if (this.produits.reseauxPersonnalise.map(el => el.selected).includes(false)) return null;
        if (this.produits.reseauxPersonnalise.every(el => el.selected === true)) return true;
      }
      const listeFilter = this.produits[produit]
        .filter(el => !el.extensionOpportunite.reseauPersoGuid);
      if (listeFilter.map(el => el.selected).includes(false)) return null;
      if (listeFilter.every(el => el.selected === true)) return true;
      return val;
    },
    verificationAllSection() {
      if (this.selectAllPanneauxLc
          && this.selectAllReseauxTempo
          && this.selectAllReseauxLc
          && this.selectAllPanneauxNumeriques
          && this.selectAllReseauxNumeriques
          && this.selectAllReseauxPersonnalise) this.selectAll = true;
      else this.selectAll = false;
    },
    suppressionProduit() {
      this.produits.panneauxLc.filter(el => el.selected).forEach((el) => this.setRemoveProduit(el));
      this.produits.panneauxNumeriques.filter(el => el.selected).forEach((el) =>
        this.setRemoveProduitPanNum(el));
      this.produits.reseauxTempo.filter(el => el.selected).forEach((el) =>
        this.setRemoveProduitReseauxTempo(el));
      this.produits.reseauxLc.filter(el => el.selected).forEach((el) =>
        this.setRemoveProduitReseauLC(el));
      this.produits.reseauxNumeriques.filter(el => el.selected).forEach((el) =>
        this.setRemoveProduitReseauxNum(el));
      this.produits.reseauxPersonnalise.filter(el => el.selected).forEach((el) =>
        this.setRemoveProduitReseauxPerso(el));
    },
    appliquerAction() {
      const activeAction = this.action;
      switch (activeAction) {
        case '1' :
          this.$parent.creerReseauPersonnalise();
          break;
        case '2' :
          this.suppressionProduit();
          break;
        default: break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  $entete-panier: 346px;
  .iconFacesLc {
    margin-top:5px;
    margin-left:5px;
    margin-bottom:5px;
  }

  .collapse-produit {
    width: 100%;
  }

  .checkbox-produit {
    margin-left: 12px;
    margin-top: -50px;
  }

  .checkbox-collapse {
    margin-left: 12px;
  }

  .reseauPersonnalise {
    margin-left: 2.8vw;
    width: 97%;
  }
  .padding-produit {
    padding-right: 20px;
    padding-top: 10px;
    padding-left: 5px;
  }
  .actionScroll {
    overflow: hidden;
    padding-right: 20px;
  }
  .width-190{
    width: 190px;
  }
  .width-200 {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/produits.vue